import React from "react";
import ReactGA from "react-ga4";
import "./SocialLinks.css";

export default function SocialLinks({ id }) {
  if (!id) return null;

  const linksById = {
    kicpod: [
      {
        href: "https://podcasts.apple.com/au/podcast/kicpod/id1457667995",
        label: "Apple Podcasts",
        img: "/apple_podcast_icon.png",
        alt: "Apple Podcasts",
      },
      {
        href: "https://open.spotify.com/show/2M7qMqeBYjhvHmpFwTrYCI",
        label: "Spotify",
        img: "/spotify_icon.png",
        alt: "Spotify",
      },
    //   {
    //     href: "https://www.instagram.com/kicpod/",
    //     label: "Instagram",
    //     img: "/instagram_icon.png",
    //     alt: "Instagram",
    //   },
    ],
    lifeuncut: [
        {
          href: "https://podcasts.apple.com/au/podcast/life-uncut/id1472126503",
          label: "Apple Podcasts",
          img: "/apple_podcast_icon.png",
          alt: "Apple Podcasts",
        },
        {
          href: "https://open.spotify.com/show/6wKBCRYUub2QJfUT7M8ZNT",
          label: "Spotify",
          img: "/spotify_icon.png",
          alt: "Spotify",
        },
        // {
        //   href: "https://www.instagram.com/lifeuncutpodcast/",
        //   label: "Instagram",
        //   img: "/instagram_icon.png",
        //   alt: "Instagram",
        // },
      ],
      mamamiaoutloud: [
        {
          href: "https://podcasts.apple.com/au/podcast/mamamia-out-loud/id928350893",
          label: "Apple Podcasts",
          img: "/apple_podcast_icon.png",
          alt: "Apple Podcasts",
        },
        {
          href: "https://open.spotify.com/show/7dPYxszTS36t2he9P9Jmcj",
          label: "Spotify",
          img: "/spotify_icon.png",
          alt: "Spotify",
        },
        // {
        //   href: "https://www.instagram.com/mamamiaoutloud/",
        //   label: "Instagram",
        //   img: "/instagram_icon.png",
        //   alt: "Instagram",
        // },
      ],
      shameless: [
        {
          href: "https://podcasts.apple.com/au/podcast/shameless/id1352875216",
          label: "Apple Podcasts",
          img: "/apple_podcast_icon.png",
          alt: "Apple Podcasts",
        },
        {
          href: "https://open.spotify.com/show/3TupxwKgi0V7iFi248fjAm",
          label: "Spotify",
          img: "/spotify_icon.png",
          alt: "Spotify",
        },
        // {
        //   href: "https://www.instagram.com/shamelesspodcast/",
        //   label: "Instagram",
        //   img: "/instagram_icon.png",
        //   alt: "Instagram",
        // },
      ],
    styleish: [
        {
          href: "https://podcasts.apple.com/au/podcast/style-ish/id1742690803",
          label: "Apple Podcasts",
          img: "/apple_podcast_icon.png",
          alt: "Apple Podcasts",
        },
        {
          href: "https://open.spotify.com/show/15Iuy1KzvnCzksa9jvoqwj",
          label: "Spotify",
          img: "/spotify_icon.png",
          alt: "Spotify",
        },
        // {
        //   href: "https://www.instagram.com/shamelesspodcast/",
        //   label: "Instagram",
        //   img: "/instagram_icon.png",
        //   alt: "Instagram",
        // },
      ],
      imperfects: [
        {
          href: "https://podcasts.apple.com/au/podcast/the-imperfects/id1476501557",
          label: "Apple Podcasts",
          img: "/apple_podcast_icon.png",
          alt: "Apple Podcasts",
        },
        {
          href: "https://open.spotify.com/show/6ZmSCzsv0W2ZZAPFCbqhOd",
          label: "Spotify",
          img: "/spotify_icon.png",
          alt: "Spotify",
        },
        // {
        //   href: "https://www.instagram.com/shamelesspodcast/",
        //   label: "Instagram",
        //   img: "/instagram_icon.png",
        //   alt: "Instagram",
        // },
      ],
      workinghard: [
        {
          href: "https://podcasts.apple.com/au/podcast/working-hard/id1569049585",
          label: "Apple Podcasts",
          img: "/apple_podcast_icon.png",
          alt: "Apple Podcasts",
        },
        {
          href: "https://open.spotify.com/show/1Uh7KMBji1BptMsUS4tNNM",
          label: "Spotify",
          img: "/spotify_icon.png",
          alt: "Spotify",
        },
        // {
        //   href: "https://www.instagram.com/shamelesspodcast/",
        //   label: "Instagram",
        //   img: "/instagram_icon.png",
        //   alt: "Instagram",
        // },
      ],
      wedonthavetimeforthis: [
        {
          href: "https://podcasts.apple.com/au/podcast/we-dont-have-time-for-this/id1544178687",
          label: "Apple Podcasts",
          img: "/apple_podcast_icon.png",
          alt: "Apple Podcasts",
        },
        {
          href: "https://open.spotify.com/show/1kGC1I1xEJiom7tqRLUKnJ",
          label: "Spotify",
          img: "/spotify_icon.png",
          alt: "Spotify",
        },
        // {
        //   href: "https://www.instagram.com/shamelesspodcast/",
        //   label: "Instagram",
        //   img: "/instagram_icon.png",
        //   alt: "Instagram",
        // },
      ],
  };
  

  const links = linksById[id];
  if (!links) return null;

  const handleClick = (e, link) => {
    e.preventDefault();
    ReactGA.event({
      category: "Landing",
      action: `Click ${id} ${link.label} Button`,
    });
    setTimeout(() => {
      window.open(link.href, "_blank");
    }, 200);
  };

  return (
    <div className="social-links">
      {links.map((link) => (
        <a
          key={link.label}
          href={link.href}
          target="_blank"
          rel="noopener noreferrer"
          className="podcast-icon-link"
          onClick={(e) => handleClick(e, link)}
        >
          <img src={link.img} alt={link.alt} className="podcast-icon" />
        </a>
      ))}
    </div>
  );
}
